var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAlert(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.03395 12.1888C-0.012193 10.3077 -0.276971 8.0907 0.296728 6.01611C0.870427 3.94153 2.23662 2.17559 4.10062 1.09923C5.96461 0.0228608 8.17701 -0.277664 10.2606 0.262478C12.3442 0.802619 14.1319 2.14014 15.2382 3.98652L16.9197 6.89832L20.8281 9.74246C20.9661 9.84296 21.0768 9.97632 21.1502 10.1305C21.2236 10.2846 21.2573 10.4546 21.2484 10.6251C21.2394 10.7956 21.188 10.9611 21.0989 11.1067C21.0097 11.2523 20.8856 11.3733 20.7379 11.4588L15.5499 14.4526L15.5581 14.4588L9.94366 17.6987V17.6925L4.75573 20.6863C4.60781 20.7721 4.44078 20.8195 4.26987 20.8242C4.09895 20.829 3.92957 20.7909 3.77713 20.7134C3.62469 20.636 3.49404 20.5216 3.39707 20.3808C3.30009 20.24 3.23988 20.0772 3.2219 19.9071L2.71541 15.1026L1.03395 12.1888Z",
    fill: "#3E3E3E"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8498 16.082L10.7021 19.6295C11.2374 20.3021 11.9962 20.7603 12.8407 20.9206C13.6852 21.081 14.5592 20.9329 15.3037 20.5032C16.0482 20.0736 16.6137 19.391 16.8975 18.5797C17.1812 17.7683 17.1643 16.882 16.8498 16.082Z",
    fill: "#3E3E3E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d6103668.svg";
export { ForwardRef as ReactComponent };